import sorts from '@/entities/sort'

var sort = {
  data() {
    return {
      sorts: sorts,
      sort: {
        direction: false,
        order: false,
      },
    }
  },
  methods: {
    collectSort(params = {}) {
      if(this.sort.direction) {
        params.direction = this.sort.direction
      }

      if(this.sort.order) {
        params.order = this.sort.order
      }

      return params
    }
  }
}

export default sort
